import snakeCase from 'lodash/snakeCase';
import { createAgentInputSchema } from './agentInputSchema';
import { createMcpCompatibleInputSchema } from './McpSchemaCompatLayer';
import { assertAvailable, createMcpToolResultBuilders, defaultAgentToModelOutput, resolveDescription, } from './toolDefinitionUtils';
export class ToolDefinitionWithoutMcpOutputImpl {
    constructor(args) {
        this.name = args.name;
        this.title = args.title;
        this.descriptionConfig = args.description;
        this.availability = args.availability;
        this.inputSchema = args.inputSchema;
        this.inputSchemaTransformed = args.inputSchemaTransformed;
        this.agentConfig = args.agentConfig;
        this.mcpConfig = args.mcpConfig;
    }
    get description() {
        return resolveDescription(this.descriptionConfig, {
            runtime: 'agent',
            toolName: this.name,
        });
    }
    buildAgentView() {
        const base = {
            name: this.name,
            title: this.title,
            description: this.description,
            inputSchema: createAgentInputSchema(this.inputSchema),
            toModelOutput: this.agentConfig?.toModelOutput ?? defaultAgentToModelOutput,
        };
        if (this.agentConfig?.outputSchema) {
            return {
                ...base,
                outputSchema: this.agentConfig.outputSchema,
            };
        }
        return base;
    }
    for(runtime) {
        assertAvailable(this.name, this.availability, runtime);
        if (runtime === 'agent') {
            return this.buildAgentView();
        }
        if (this.mcpConfig === null) {
            throw new Error(`Tool "${this.name}" is missing MCP config`);
        }
        const mcpName = this.mcpConfig.name ?? snakeCase(this.name);
        return {
            name: mcpName,
            canonicalName: this.name,
            title: this.title,
            description: resolveDescription(this.descriptionConfig, {
                runtime: 'mcp',
                toolName: mcpName,
            }),
            inputSchema: createMcpCompatibleInputSchema(this.inputSchema),
            annotations: { title: this.title, ...this.mcpConfig.annotations },
            meta: this.mcpConfig.meta,
            result: createMcpToolResultBuilders(),
        };
    }
}
//# sourceMappingURL=toolDefinitionWithoutMcpOutput.js.map